/** @import { ItineraryDayGroup } from '../../types/itinerary-day-group' */

import { formatPortName } from '../../utils/cruise';
import { Excursion } from '../excursion/excursion';
import classes from './excursion-list.module.css';

/**
 * @param  {object} props
 * @param {ItineraryDayGroup} props.day
 * @returns {React.JSX.Element}
 */
export function ExcursionList({ day }) {
  const dayName = formatPortName(day.ports.at(0));

  return (
    <div className={classes.excursionList}>
      <div className={classes.information}>
        <h1 className={classes.informationTitle}>Shore Excursions</h1>
        <h2 className={classes.informationSubtitle}>
          Shore excursions vary by each itinerary and are subject to change.
        </h2>
      </div>
      {day.excursions.map((excursion, excursionIndex) => (
        <Excursion key={excursionIndex} dayName={dayName} excursion={excursion} />
      ))}
    </div>
  );
}
